module.exports = __webpack_public_path__ + "img/login-ontaneda.726e0d6c.svg";